import Cookies from 'js-cookie'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getLanguageList } from '@common/oneclub/hooks/useLanguage'
import type { AppGetState, AppThunkDispatch } from '@common/oneclub/store'
import type * as Types from './types'
import { getSellerBasic, getUserPermission, SysResource } from '@common/oneclub/services/api'
import { KYC_MEMU_COUNTRY } from '@common/oneclub/constants'

const initialState: Types.UserInitState = {
  osudb_uid: Cookies.get('osudb_uid') || '',
  osudb_subappid: Cookies.get('osudb_subappid') || '',
  languageList: [],
  adminTicket: '',
  permission: {},
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo(state, action: PayloadAction<Types.UserInfo>) {
      const newState = {
        ...state,
        info: {
          ...action.payload,
        },
      }

      return newState
    },
    setLanguageList(state, action: PayloadAction<Types.UserInitState['languageList']>) {
      return {
        ...state,
        languageList: action.payload,
      }
    },
    /** 保存超管登录ticket */
    setAdminTicket(state, action: PayloadAction<string>) {
      return {
        ...state,
        adminTicket: action.payload,
      }
    },
    setPermission(state, action: PayloadAction<Record<string, boolean>>) {
      return {
        ...state,
        permission: action.payload,
      }
    },
  },
})

/** 获取用户信息 */
export const getUserInfo = () => async (dispatch: AppThunkDispatch) => {
  const { data: userInfo } = await getSellerBasic()
  const { countryCode } = userInfo || {}

  dispatch(
    userSlice.actions.setUserInfo({
      ...userInfo,
    })
  )

  dispatch(setLanguageList(getLanguageList(countryCode)))
  dispatch(getPermission())
  return userInfo
}

function mapSysResource(prefix: string, resourceTree: SysResource[], res: any) {
  resourceTree.forEach((item) => {
    res[`${prefix ? prefix + ':' : ''}${item.resourceCode}`] = true
    if (item.children?.length) {
      mapSysResource(prefix, item.children, res)
    }
  })
}

/** 获取商家权限 */
const getPermission = () => async (dispatch: AppThunkDispatch, getState: AppGetState) => {
  const userInfo = getState().user.info
  const [osResourceTree, owResourceTree] = await Promise.all([
    getUserPermission({ sourceSystem: 'ONESHIP', adminUid: userInfo.uid }),
    getUserPermission({ sourceSystem: 'ONEWAREHOUSE', adminUid: userInfo.uid }),
  ])
  const apply = KYC_MEMU_COUNTRY.includes(userInfo?.countryCode)
  const root = typeof userInfo?.mainAccount === 'boolean' ? userInfo?.mainAccount : false
  const permission = { root, apply } // 补充两个默认权限，兼容旧代码
  mapSysResource('OS', osResourceTree, permission)
  mapSysResource('OW', owResourceTree, permission)
  dispatch(userSlice.actions.setPermission(permission))
}

export const { setUserInfo, setLanguageList, setAdminTicket } = userSlice.actions
export default userSlice.reducer
